import React from 'react';
import { Section } from './ui/Section';
import { Check } from 'lucide-react';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function PricingSection() {
  const handleBuyClick = () => {
    trackAddToCart({
      content_name: 'Energía Alta (Mediterránea)',
      content_ids: ['55907426042182'],
      content_type: 'product',
      value: 6.39,
      currency: 'USD'
    });
  };
  return <Section id="pricing" className="bg-white" data-id="element-283">
      <div className="max-w-md mx-auto bg-[#faf8f5] rounded-3xl shadow-2xl overflow-hidden border-2 border-[#2c4a2c]/10" data-id="element-284">
        <div className="bg-[#2c4a2c] p-6 text-center text-white" data-id="element-285">
          <h2 className="text-2xl font-bold mb-1" data-id="element-286">Energía Alta</h2>
          <p className="text-[#d4a853] font-medium text-sm" data-id="element-287">(Mediterránea)</p>
          <div className="mt-4 flex items-baseline justify-center gap-1" data-id="element-288">
            <span className="text-4xl font-bold" data-id="element-289">$6.39</span>
            <span className="text-sm opacity-80" data-id="element-290">/ único</span>
          </div>
          <p className="text-xs mt-3 opacity-80" data-id="element-291">
            Un pago. Uso ilimitado. Plantillas para repetir durante meses.
          </p>
        </div>

        <div className="p-6" data-id="element-292">
          <div className="space-y-3 mb-6" data-id="element-293">
            <p className="font-bold text-[#2c4a2c] mb-3 text-sm" data-id="element-294">Incluye:</p>
            {['Ebook completo', 'Plantillas de comidas y micro-ajustes', 'Plan 14 días + tracker energía 16:30', 'Sistema de corrección en 48 horas'].map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-295">
                <Check className="w-4 h-4 text-[#c45d3a] shrink-0 mt-0.5" data-id="element-296" />
                <span className="text-[#5a5a5a] text-sm" data-id="element-297">{item}</span>
              </div>)}
          </div>

          <a href="https://www.cuidarte360.com/cart/55907426042182:1" target="_blank" rel="noopener noreferrer" onClick={handleBuyClick} className="block w-full bg-[#c45d3a] text-white p-3 rounded-lg mb-5 text-center shadow-xl shadow-[#c45d3a]/40 hover:bg-[#a84a2a] hover:shadow-2xl hover:shadow-[#a84a2a]/50 cursor-pointer transition-all active:scale-[0.98] hover:scale-[1.01]" data-id="element-298">
            <p className="text-xs font-medium" data-id="element-299">Quiero energía alta por solo</p>
            <p className="text-xl font-bold mt-1" data-id="element-300">$6.39</p>
          </a>

          <div className="text-center" data-id="element-301">
            <p className="text-xs text-[#5a5a5a]/70" data-id="element-302">
              Acceso inmediato tras la compra.
            </p>
          </div>
        </div>
      </div>

      <p className="text-center text-sm text-[#5a5a5a]/60 mt-8" data-id="element-303">
        © {new Date().getFullYear()} Energía Alta (Mediterránea). Todos los
        derechos reservados.
      </p>
    </Section>;
}